import { theme } from 'styles';

export const defaultStyles = {
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    background: theme.palette.white.main,
    boxShadow: 'none',
    height: '56px',
    border: `1px solid ${theme.palette.primary.grey}`,
    '&:hover': { border: `1px solid ${theme.palette.primary.grey}` },
    '&.Mui-focused': { border: `1px solid ${theme.palette.primary.grey}` },
    '&.Mui-error': { border: `1px solid ${theme.palette.error.main}` },
  },
  '& .MuiInputBase-root.Mui-error .MuiInputBase-input': {
    border: 'none',
    borderRadius: '4px',
  },
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    height: '56px',
    alignItems: 'center',
    fontSize: '14px',
    padding: '0 12px',
    boxSizing: 'border-box',
    '&:focus': { background: 'none' },
  },
  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.p030,
  },
};
export const disableStyles = {
  '& .MuiInputBase-root': {
    borderRadius: '4px',
    background: theme.palette.white.main,
    boxShadow: 'none',
    height: '56px',
    border: `1px solid ${theme.palette.primary.grey}`,
    '&:hover': { border: `1px solid ${theme.palette.primary.grey}` },
    '&.Mui-focused': { border: `1px solid ${theme.palette.primary.grey}` },
  },
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    height: '56px',
    alignItems: 'center',
    fontSize: '14px',
    padding: '0 12px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.primary.grey}`,

    cursor: 'not-allowed',
    '&:focus': { background: 'none' },
  },
  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.p030,
  },
};

export const defaultdisableMobileStyles = {
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',
    backgroundColor: theme.palette.white.main,
    cursor: 'not-allowed',

    '&:focus': {
      background: 'none',
    },
  },

  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.p030,
  },
};

export const defaultMobileStyles = {
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',

    '&:focus': {
      background: 'none',
    },
  },

  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.p030,
  },
};

export const multipleSelectStyles = {
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    background: '#fff',
    boxShadow: 'none',
    minHeight: '56px',
    paddingLeft: '8px',
    height: 'auto',
    border: `1px solid ${theme.palette.primary.grey}`,
    '&:hover': { border: `1px solid ${theme.palette.primary.grey}` },
    '&.Mui-focused': { border: `1px solid ${theme.palette.primary.grey}` },
  },
  '& .MuiSelect-select.MuiSelect-select': {
    display: 'flex',
    minHeight: '56px',
    height: 'auto',
    alignItems: 'center',
    fontSize: '14px',
    padding: '0',
    boxSizing: 'border-box',
    '&:focus': { background: 'none' },
  },
  '& .MuiSelect-icon': {
    fontSize: '24px',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.p030,
  },
};

export const menuItemStyles = {
  fontSize: '14px',
  padding: '8px 24px',
  '&:hover': { backgroundColor: theme.palette.info.light },
};
